import React, { useEffect, useMemo, useRef, useState } from "react";
import "../../assets/styles/orgchart-responsive.scss";

type OrgChartResponsiveProps = {
    /** SVG’yi string olarak (önerilir). Vite/Webpack’te `import svg from './chart.svg?raw'` ile gelebilir */
    svg?: string;
    /** Ya da dosya yolu (public yol). Sadece birini ver. */
    src?: string;
    /** Başlık (opsiyonel) */
    title?: string;
    /** Başlangıç yakınlaştırma (1 = %100) */
    initialScale?: number;
    /** Maksimum konteyner genişliği (px ya da css değeri) */
    maxWidth?: string | number;
    /** Görünür alan yüksekliği (min-height). Örn: "60vh" */
    viewportHeight?: string;
};

const clamp = (v: number, min: number, max: number) => Math.max(min, Math.min(max, v));

const OrgChartResponsive: React.FC<OrgChartResponsiveProps> = ({
    svg,
    src,
    title = "Organizasyon Şeması",
    initialScale = 1,
    maxWidth = 1200,
    viewportHeight = "65vh",
}) => {
    const [scale, setScale] = useState(clamp(initialScale, 0.25, 4));
    const canvasRef = useRef<HTMLDivElement | null>(null);

    // Mouse tekerleği ile zoom (Ctrl + wheel için sistem zoom'u devreye girmesin)
    useEffect(() => {
        const el = canvasRef.current?.parentElement; // viewport
        if (!el) return;

        const onWheel = (e: WheelEvent) => {
            if (!e.ctrlKey) return; // yanlışlıkla sayfa zoom’lamayalım
            e.preventDefault();
            const next = clamp(scale - Math.sign(e.deltaY) * 0.1, 0.25, 4);
            setScale(next);
        };

        el.addEventListener("wheel", onWheel, { passive: false });
        return () => el.removeEventListener("wheel", onWheel);
    }, [scale]);



    return (
        <>

            <section className="orgchart">
                <div className="orgchart__container" style={{ maxWidth }}>
                    <header className="orgchart__head">
                        <h2 className="orgchart__title">{title}</h2>
                    </header>

                    <div
                        className="orgchart__viewport"
                        style={{ minHeight: viewportHeight }}
                        role="region"
                        aria-label="Organizasyon şeması"
                    >
                        <img src={src} alt="" />

                    </div>

                </div>
            </section>
        </>
    );
};

export default OrgChartResponsive;
